import { faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Circle } from '../../../../Common.jsx.js';
import React from 'react';

const DNRComponent = (isPhoto) => {
  const left = isPhoto ? '5px' : '15px';
  const top = isPhoto ? '-3px' : '24px';

  return (
    <div style={{ position: 'relative', left, top }}>
      <Circle>
        <p style={{ padding: 0, margin: 0 }}>DNR</p>
      </Circle>
    </div>
  );
};

const renderAvatar = (photoUrl, enableDoNotRank) => {
  if (photoUrl && photoUrl !== '') {
    return (
      <div style={{ minHeight: '52px' }}>
        <img style={{ width: '52px', height: 'auto' }} src={photoUrl}></img>
        {enableDoNotRank && DNRComponent(true)}
      </div>
    );
  }

  return (
    <div
      style={{
        width: '52px',
        height: '52px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <FontAwesomeIcon icon={faUser} style={{ fontSize: '2.67em' }} />
      {enableDoNotRank && DNRComponent(false)}
    </div>
  );
};

export { renderAvatar };
